<template>
  <div class="superuser-info-table">
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        {{ tStatic("superUserProductInfoStockAvailable") }}
        <!-- Aktuellt lagersaldo: -->
      </div>
      <div class="superuser-info-table__column">
        {{ stockAvailable }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Ledtid för huvudleverantör: -->
        {{ tStatic("superUserProductInfoDeliverTime") }}
      </div>
      <div class="superuser-info-table__column">
        {{ deliveryTime }}
      </div>
    </div>

    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Beräknad åter i lager: -->
        {{ tStatic("superUserProductInfoDeliverDate") }}
      </div>
      <div class="superuser-info-table__column">
        {{ deliveryDate }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Inköpspris -->
        {{ tStatic("superUserPurchasePrice") }}
      </div>
      <div class="superuser-info-table__column">
        {{ purchasePrice }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Monteringsdetaljer -->
        {{ tStatic("superUserItemAssemblyDetails") }}
      </div>
      <div class="superuser-info-table__column">
        {{ itemAssemblyDetails }}
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    productNumber: {
      type: String,
      required: true
    },
    itemNumber: {
      type: String,
      required: true
    }
  },
  data: () => ({
    stockAvailable: null,
    deliveryTime: null,
    deliveryDate: null,
    purchasePrice: null,
    itemAssemblyDetails: null
  }),
  computed: {},
  mounted() {
    httpService
      .get('superuser/product/', {
        productNumber: this.productNumber,
        itemNumber: this.itemNumber
      })
      .then(response => {
        this.stockAvailable = response.data.stockAvailable
        this.deliveryTime = response.data.deliveryTime
        this.deliveryDate = response.data.deliveryDate
        this.purchasePrice = response.data.purchasePrice
        this.itemAssemblyDetails = response.data.itemAssemblyDetails
      })
  }
}
</script>

<style lang="scss">
.superuser-info-table {
  display: table;
}

.superuser-info-table__row {
  display: table-row;
}

.superuser-info-table__head {
  display: table-cell;
  padding-right: measure(quarter);
  padding-bottom: measure(quarter);
}

.superuser-info-table__column {
  display: table-cell;
  font-weight: bold;
}
</style>
